// extracted by mini-css-extract-plugin
export default {"headerImage":"header-image_headerImage__ZC62O"};